export const config = {
  cognito: {
    region: import.meta.env.VITE_COGNITO_REGION,
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
    domain: import.meta.env.VITE_COGNITO_DOMAIN,
  },
  app: {
    url: import.meta.env.VITE_APP_URL,
    apiBase: import.meta.env.VITE_API_BASE || "/api",
  },
} as const;

export const cognitoAuthority = () =>
  `https://cognito-idp.${config.cognito.region}.amazonaws.com/${config.cognito.userPoolId}`;

export const cognitoHostedUiBase = () =>
  `https://${config.cognito.domain}`;
